<template>
  <div class="wrap">
    <img :src="data.config.imgUrl" alt="cover" />
    <div
      class="zone"
      v-for="(zone, index) in data.data"
      :key="index"
      :style="{
          width: getZoneStyle(zone.widthPer),
          height: getZoneStyle(zone.heightPer),
          top: getZoneStyle(zone.topPer),
          left: getZoneStyle(zone.leftPer)
        }"
      @click="handleZoneClick(zone)"
    ></div>
  </div>
</template>
<script>
import { openToLink } from "/utils/openToLink";

export default {
  name: "imgHotzone",
  props: ["data", "usage"],
  methods: {
    handleZoneClick(row) {
      openToLink(row.linkPage,row)

      
      // let href = null;
      // switch (row.linkPage) {
      //   case "category":
      //     href = `/#/goods?categoryId=${row.id}`;
      //     break;
      //   case "goods":
      //     href = `/#/goodsDetails?itemId=${row.id}`;
      //     this.usage === "store" && (href = href + `&id=${this.$route.query.id}`);
      //     break;
      //   case "custom_page":
      //     href = `/#/custompage?itemId=${row.id}`;
      //     break;
      //   default:
      //     break;
      // }
      // window.open("//" + window.location.host + href);
    },
    getZoneStyle(val) {
      return `${(val || 0) * 100}%`;
    }
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  position: relative;
}
.wrap img {
  width: 100%;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
}
.wrap .zone {
  position: absolute;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// imgHotZone.vue?42b2a360